import axios, { baseUrl } from './axios';

export default {
  loadStaffDetail: async (options = {}) => {
    const result = await axios.get(
      `${baseUrl}/customer/mob/staffs/${options.staffId}`,
    );
    return result.data;
  },

  createStaff: async data => {
    const result = await axios.post(`${baseUrl}/customer/staffs`, data);
    return result.data;
  },
  updateStaff: async data => {
    const result = await axios.put(
      `${baseUrl}/customer/staffs/${data.staff.id}`,
      data,
    );
    return result.data;
  },
};
